<main class="mx-auto w-full max-w-2xl px-4 pb-16 pt-6 text-strong sm:pt-10">
    <div *ngIf="loading" class="flex animate-pulse flex-col items-center gap-4" role="status" aria-label="Caricamento">
        <div class="h-14 w-14 rounded-full bg-slate-200"></div>
        <div class="h-6 w-72 max-w-full rounded bg-slate-200"></div>
        <div class="h-48 w-full rounded-2xl border border-slate-200 bg-white"></div>
    </div>

    <ng-container *ngIf="!loading">
        <!-- Intestazione -->
        <header class="mb-8 flex flex-col items-center text-center">
            <span class="mb-4 grid h-14 w-14 place-items-center rounded-full text-2xl"
                  [ngClass]="isFlagged ? 'bg-primary-soft text-primary' : 'bg-amber-50 text-amber-600'">
                <i class="bi" [ngClass]="isFlagged ? 'bi-bank' : 'bi-hourglass-split'" aria-hidden="true"></i>
            </span>
            <h1 class="m-0 text-2xl font-bold tracking-tight text-strong sm:text-3xl">
                <ng-container *ngIf="isFlagged">{{ isShopOrder ? 'Ordine registrato' : 'Richiesta di iscrizione inviata' }}</ng-container>
                <ng-container *ngIf="!isFlagged">Pagamento in attesa di verifica</ng-container>
            </h1>
            <p class="mb-0 mt-2 max-w-md text-sm leading-6 text-slate-600">
                <ng-container *ngIf="isFlagged">Completa il bonifico con i dati qui sotto: la società confermerà il pagamento appena lo riceve.</ng-container>
                <ng-container *ngIf="!isFlagged">Completa il pagamento in segreteria: la società lo verificherà e aggiornerà lo stato dell'iscrizione.</ng-container>
            </p>
        </header>

        <!-- Dati bonifico -->
        <section *ngIf="isFlagged" class="mb-6 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6" aria-labelledby="transfer-title">
            <h2 id="transfer-title" class="mb-4 mt-0 text-base font-bold text-strong">Dati per il bonifico</h2>

            <p *ngIf="!wireTransferIban && !wireTransferBeneficiary" class="m-0 rounded-lg bg-amber-50 px-3 py-2.5 text-sm text-amber-800">
                I dati del bonifico non sono disponibili: contatta la società sportiva.
            </p>

            <dl *ngIf="wireTransferIban || wireTransferBeneficiary" class="m-0 flex flex-col gap-3">
                <ng-container *ngTemplateOutlet="copyRow; context: {label: 'IBAN', value: formattedIban, field: 'iban', mono: true}"></ng-container>
                <ng-container *ngTemplateOutlet="copyRow; context: {label: 'Beneficiario', value: wireTransferBeneficiary, field: 'beneficiary', mono: false}"></ng-container>
                <ng-container *ngTemplateOutlet="copyRow; context: {label: 'Causale', value: transferReason, field: 'reason', mono: false}"></ng-container>
            </dl>

            <p *ngIf="!isShopOrder" class="mb-0 mt-4 flex items-start gap-2 text-xs leading-5 text-slate-500">
                <i class="bi bi-envelope mt-0.5 shrink-0" aria-hidden="true"></i>
                Ti abbiamo inviato questi dati anche via email.
            </p>
        </section>

        <!-- Pagamento in segreteria -->
        <section *ngIf="!isFlagged && (company.name || companyAddress)" class="mb-6 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6" aria-labelledby="office-title">
            <h2 id="office-title" class="mb-3 mt-0 text-base font-bold text-strong">Dove pagare</h2>
            <div class="flex items-start gap-3">
                <span class="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-slate-100 text-lg text-slate-600">
                    <i class="bi bi-geo-alt" aria-hidden="true"></i>
                </span>
                <div class="min-w-0 text-sm leading-6">
                    <p *ngIf="company.name" class="m-0 font-semibold text-strong">{{ company.name }}</p>
                    <p *ngIf="companyAddress" class="m-0 text-slate-600">{{ companyAddress }}</p>
                    <a *ngIf="company.receivingEmail" [href]="'mailto:' + company.receivingEmail" class="font-semibold">{{ company.receivingEmail }}</a>
                </div>
            </div>
        </section>

        <!-- Prossimi passi -->
        <section class="mb-8 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6" aria-labelledby="steps-title">
            <h2 id="steps-title" class="mb-4 mt-0 text-base font-bold text-strong">Cosa succede ora</h2>
            <ol class="m-0 flex list-none flex-col gap-4 p-0">
                <li class="flex gap-3">
                    <span class="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-primary text-xs font-bold text-white">1</span>
                    <span class="text-sm leading-6 text-slate-700">
                        <ng-container *ngIf="isFlagged">Effettua il bonifico indicando la causale.</ng-container>
                        <ng-container *ngIf="!isFlagged">Paga presso la segreteria della società.</ng-container>
                    </span>
                </li>
                <li class="flex gap-3">
                    <span class="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-slate-100 text-xs font-bold text-slate-600">2</span>
                    <span class="text-sm leading-6 text-slate-700">La società verifica il pagamento.</span>
                </li>
                <li class="flex gap-3">
                    <span class="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-slate-100 text-xs font-bold text-slate-600">3</span>
                    <span class="text-sm leading-6 text-slate-700">
                        {{ isShopOrder ? "Riceverai la conferma dell'ordine." : "L'iscrizione risulterà pagata nella tua area riservata e potrai scaricare la ricevuta." }}
                    </span>
                </li>
            </ol>
        </section>

        <div class="flex justify-center">
            <a [routerLink]="backRoute" class="btn btn-primary inline-flex min-h-[44px] w-full items-center justify-center gap-2 sm:w-auto">
                {{ isShopOrder ? 'Torna allo shop' : "Torna all'area riservata" }}
            </a>
        </div>
    </ng-container>
</main>

<ng-template #copyRow let-label="label" let-value="value" let-field="field" let-mono="mono">
    <div class="flex items-center justify-between gap-3 rounded-xl bg-slate-50 px-4 py-3">
        <div class="min-w-0">
            <dt class="text-xs font-semibold uppercase tracking-wide text-slate-500">{{ label }}</dt>
            <dd class="m-0 break-words text-sm font-semibold text-strong" [class.font-mono]="mono" [class.tracking-wide]="mono">{{ value || '—' }}</dd>
        </div>
        <button *ngIf="value" type="button"
                class="inline-flex min-h-[40px] shrink-0 items-center gap-1.5 rounded-lg border border-solid border-slate-200 bg-white px-3 text-sm font-semibold transition hover:border-primary"
                [ngClass]="copiedField === field ? 'text-emerald-700' : 'text-slate-700'"
                [attr.aria-label]="'Copia ' + label"
                (click)="copy(field)">
            <i class="bi" [ngClass]="copiedField === field ? 'bi-check-lg' : 'bi-copy'" aria-hidden="true"></i>
            {{ copiedField === field ? 'Copiato' : 'Copia' }}
        </button>
    </div>
</ng-template>
